import { Controller } from "@hotwired/stimulus"

const TREE = {
  start: {
    message: "Bonjour, je suis là pour vous orienter vers les bonnes démarches. Comment puis-je vous aider ?",
    options: [
      { label: "Je suis victime d'une infraction", next: "categorie" },
      { label: "Je suis témoin d'une infraction", next: "temoin" }
    ]
  },

  categorie: {
    message: "Quel type d'infraction avez-vous subi ?",
    options: [
      { label: "Vol / Cambriolage", next: "vol" },
      { label: "Violences physiques", next: "violence_physique" },
      { label: "Violence conjugale / intrafamiliale", next: "violence_conjugale" },
      { label: "Violence sexuelle", next: "violence_sexuelle" },
      { label: "Accident de la route", next: "accident" },
      { label: "Fraude / Escroquerie", next: "fraude" },
      { label: "Cybercriminalité", next: "cyber" },
      { label: "Harcèlement", next: "harcelement" },
      { label: "Dégradations / Vandalisme", next: "degradations" },
      { label: "Menaces", next: "result_menaces" },
      { label: "Discrimination / Racisme", next: "result_discrimination" },
      { label: "Autre infraction", next: "result_autre" }
    ]
  },

  // ── Vol ──────────────────────────────────────────────────────────────────
  vol: {
    message: "Quel type de vol avez-vous subi ?",
    options: [
      { label: "Cambriolage de mon domicile", next: "result_cambriolage" },
      { label: "Vol de / dans mon véhicule", next: "result_vol_vehicule" },
      { label: "Vol avec violence / à l'arraché", next: "result_vol_violence" },
      { label: "Vol à l'étalage", next: "result_vol_magasin" },
      { label: "Vol d'identité / documents", next: "result_vol_identite" }
    ]
  },

  // ── Violence physique ────────────────────────────────────────────────────
  violence_physique: {
    message: "Quelle est la nature des violences ?",
    options: [
      { label: "Coups et blessures", next: "result_coups_blessures" },
      { label: "Violence au sein d'un établissement scolaire", next: "result_violence_scolaire" }
    ]
  },

  // ── Violence conjugale ───────────────────────────────────────────────────
  violence_conjugale: {
    message: "Avez-vous besoin d'une aide immédiate ?",
    options: [
      { label: "Oui, je suis en danger immédiat", next: "result_vio_conj_urgence" },
      { label: "Non, je veux porter plainte", next: "result_vio_conj_plainte" },
      { label: "Je cherche des informations / soutien", next: "result_vio_conj_info" }
    ]
  },

  // ── Violence sexuelle ────────────────────────────────────────────────────
  violence_sexuelle: {
    message: "Les faits sont-ils récents (moins de 72h) ?",
    options: [
      { label: "Oui, les faits viennent de se produire", next: "result_vs_urgent" },
      { label: "Non, les faits sont plus anciens", next: "result_vs_plainte" },
      { label: "Il s'agit de harcèlement sexuel répété", next: "result_harcelement_sexuel" }
    ]
  },

  // ── Accident ─────────────────────────────────────────────────────────────
  accident: {
    message: "Quelle est la situation ?",
    options: [
      { label: "Accident avec blessés (urgent)", next: "result_accident_blesses" },
      { label: "Accident avec dégâts matériels uniquement", next: "result_accident_materiel" },
      { label: "Délit de fuite", next: "result_delit_fuite" },
      { label: "Accident sur parking privé", next: "result_accident_parking" }
    ]
  },

  // ── Fraude ───────────────────────────────────────────────────────────────
  fraude: {
    message: "Quel type d'escroquerie avez-vous subi ?",
    options: [
      { label: "Arnaque commerciale / abus de confiance", next: "result_arnaque" },
      { label: "Fraude bancaire / skimming", next: "result_fraude_bancaire" },
      { label: "Faux policier / faux agent", next: "result_faux_policier" },
      { label: "Escroquerie à la location", next: "result_escroquerie_loc" },
      { label: "Abus de faiblesse / personne âgée", next: "result_abus_faiblesse" }
    ]
  },

  // ── Cyber ─────────────────────────────────────────────────────────────────
  cyber: {
    message: "Quel type de cybercriminalité ?",
    options: [
      { label: "Phishing / hameçonnage", next: "result_phishing" },
      { label: "Piratage de compte (email, réseau social)", next: "result_piratage" },
      { label: "Sextorsion / chantage en ligne", next: "result_sextorsion" },
      { label: "Achat en ligne / colis non reçu", next: "result_achat_ligne" },
      { label: "Faux support technique", next: "result_faux_support" }
    ]
  },

  // ── Harcèlement ──────────────────────────────────────────────────────────
  harcelement: {
    message: "Quel type de harcèlement ?",
    options: [
      { label: "Harcèlement", next: "result_stalking" },
      { label: "Cyberharcèlement", next: "result_cyberharcelement" },
      { label: "Harcèlement au travail", next: "result_harcelement_travail" },
      { label: "Harcèlement de rue / sexiste", next: "result_harcelement_rue" }
    ]
  },

  // ── Dégradations ─────────────────────────────────────────────────────────
  degradations: {
    message: "Quel type de dégradations ?",
    options: [
      { label: "Dégradation de mon véhicule", next: "result_degradation_vehicule" },
      { label: "Dégradation de mon habitation / propriété", next: "result_degradation_habitation" },
      { label: "Tags / graffitis", next: "result_tags" },
      { label: "Destruction de boîte aux lettres / sonnette", next: "result_degradation_mobilier" }
    ]
  },

  // ── Témoin ────────────────────────────────────────────────────────────────
  temoin: {
    message: "Que souhaitez-vous faire ?",
    options: [
      { label: "Signaler une infraction en cours (urgent)", next: "result_temoin_urgent" },
      { label: "Déposer une déclaration de témoin", next: "result_temoin_declaration" }
    ]
  },

  // ════════════════════════════════════════════════════════════════════════
  // RÉSULTATS
  // ════════════════════════════════════════════════════════════════════════

  result_cambriolage: {
    type: "result", urgence: false,
    title: "Cambriolage",
    steps: [
      "Ne touchez à rien et ne pénétrez pas à l'intérieur si l'auteur pourrait encore être présent.",
      "Appelez le <strong>112</strong> pour signaler les faits et demander un constat.",
      "Attendez l'arrivée des policiers avant de nettoyer ou de ranger.",
      "Contactez votre assurance habitation dès que possible."
    ],
    apporter: ["Liste des objets volés avec marque, modèle, numéro de série", "Si vous en avez des photos des objets de valeur qui ne sont pas identifiés par un numéro de série", "Documents d'identité", "Coordonnées de votre assurance"],
    contact: "112 (urgence)"
  },

  result_vol_vehicule: {
    type: "result", urgence: false,
    title: "Vol de / dans un véhicule",
    steps: [
      "Appelez le <strong>112</strong> pour signaler les faits et demander un constat.",
      "En cas de vol du véhicule entier, pensez également à appeler votre assurance.",
      "Si votre carte de banque est dans le véhicule volé, bloquez-la immédiatement via <strong>Card Stop : 078/170.170</strong>."
    ],
    apporter: ["Plaque d'immatriculation, marque et modèle du véhicule", "Liste des objets volés à l'intérieur", "Documents d'identité", "Certificat d'immatriculation le volet maison de celui-ci"],
    contact: "112 (urgence)"
  },

  result_vol_violence: {
    type: "result", urgence: true,
    title: "Vol avec violence / à l'arraché",
    steps: [
      "Mettez-vous en sécurité et appelez le <strong>112</strong> immédiatement.",
      "Si vous êtes blessé(e), demandez une assistance médicale.",
      "Notez toute description de l'auteur (vêtements, taille, direction de fuite, véhicule).",
      "Ne poursuivez pas l'auteur."
    ],
    apporter: ["Documents d'identité", "Description de l'auteur et des faits", "Certificat médical si vous en disposez (ce n'est pas obligatoire, cela peut aussi faire ressortir un traumatisme)"],
    contact: "112 (urgence)"
  },

  result_vol_tire: {
    type: "result", urgence: false,
    title: "Pickpocket / Vol à la tire",
    steps: [
      "Bloquez immédiatement votre carte bancaire si elle a été volée : <strong>Card Stop 078/170.170</strong>.",
      "Signalez la perte de votre carte d'identité à la commune.",
      "Déposez plainte au commissariat."
    ],
    apporter: ["Liste des objets volés", "Lieu et heure précis des faits", "Documents d'identité (ou déclaration de perte)"],
    contact: "Card Stop : 078/170.170 — 069/66.98.20 (Péruwelz) — 069/59.02.10 (Bernissart)"
  },

  result_vol_magasin: {
    type: "result", urgence: false,
    title: "Vol à l'étalage",
    steps: [
      "Si l'auteur est encore dans le magasin,Appelez le <strong>112</strong>. Sinon évaluez le montant du préjudice",
      "Déposez plainte au commissariat.",
      "Conservez toute preuve (images de caméra de surveillance, témoignages de collègues)."
    ],
    apporter: ["Description des objets volés", "Preuves éventuelles (photos, extraits vidéo)", "Documents d'identité"],
    contact: "112 (urgence) ou 069/66.98.20 (Péruwelz) — 069/59.02.10 (Bernissart)"
  },

  result_vol_identite: {
    type: "result", urgence: false,
    title: "Vol d'identité / Documents",
    steps: [
      "Pour éviter toute usurpation d'identité signalez directement la situation auprès de Doc Stop (0080021232123)",
      "Signalez la perte ou le vol à la commune pour votre carte d'identité.",
      "Bloquez vos comptes bancaires si nécessaire via Card Stop.",
      "Déposez plainte au commissariat."
    ],
    apporter: ["Tout document prouvant votre identité", "Liste des documents volés", "Preuve de l'infraction si disponible"],
    contact: "Card Stop : 078/170.170 — 069/66.98.20 (Péruwelz)"
  },

  result_coups_blessures: {
    type: "result", urgence: true,
    title: "Coups et blessures",
    steps: [
      "Mettez-vous en sécurité.",
      "Si vous avez besoin de soins, rendez-vous aux urgences ou appelez le <strong>112</strong>.",
      "Faites établir un <strong>certificat médical</strong> par un médecin — conservez-le précieusement.",
      "Appelez le <strong>112</strong> ou déposez plainte au commissariat.",
      "Notez l'identité de témoins éventuels."
    ],
    apporter: ["Certificat médical décrivant les blessures (ce n'est pas obligatoire, mais c'est un plus pour votre dossier).", "Identité de témoins", "Documents d'identité", "Photos des blessures si possible (Elles peuvent être prises par le ou la policière)","La description du/des suspects"],
    contact: "112 (urgence)"
  },

  result_agression_rue: {
    type: "result", urgence: true,
    title: "Agression dans la rue",
    steps: [
      "Mettez-vous en sécurité et appelez le <strong>112</strong>.",
      "Si vous êtes blessé(e), appelez le <strong>112</strong>.",
      "Essayez de mémoriser la description de l'agresseur.",
      "Faites constater vos blessures par un médecin."
    ],
    apporter: ["Certificat médical", "Description de l'agresseur", "Lieu et heure précis"],
    contact: "112 (urgence) — 112 (soins)"
  },

  result_rixe: {
    type: "result", urgence: true,
    title: "Rixe / Bagarre",
    steps: [
      "Quittez les lieux pour votre sécurité et appelez le <strong>112</strong>.",
      "Faites constater vos blessures par un médecin.",
      "Déposez plainte au commissariat."
    ],
    apporter: ["Certificat médical", "Identité ou description des personnes impliquées", "Témoignages"],
    contact: "112 (urgence)"
  },

  result_violence_scolaire: {
    type: "result", urgence: false,
    title: "Violence en milieu scolaire",
    steps: [
      "Si vous êtes mineur (moins de 18 ans), parlez-en à vos parents.",
      "Informez immédiatement la direction de l'établissement.",
      "Faites constater les blessures par un médecin.",
      "Déposez plainte au commissariat.",
      "Vous pouvez aussi contacter l'inspection scolaire de votre réseau."
    ],
    apporter: ["Certificat médical", "Nom de l'établissement et de la personne impliquée", "Témoins éventuels"],
    contact: "069/66.98.20 (Péruwelz) — 069/59.02.10 (Bernissart)"
  },

  result_vio_conj_urgence: {
    type: "result", urgence: true,
    title: "Violence conjugale — Danger immédiat",
    steps: [
      "Appelez le <strong>112</strong> immédiatement — la police interviendra.",
      "Si vous ne pouvez pas parler, envoyez un SMS au 112 ou utilisez le code convenu.",
      "Quittez le domicile si vous pouvez le faire en sécurité.",
      "Rendez-vous aux urgences si vous êtes blessé(e) (112)."
    ],
    apporter: [],
    contact: "112 (urgence) — 0800/30.030 (SOS Violence conjugale, gratuit 24h/24)",
    extra: "Numéro d'aide gratuit : <strong>0800/30.030</strong> (SOS Violence conjugale)"
  },

  result_vio_conj_plainte: {
    type: "result", urgence: false,
    title: "Violence conjugale — Déposer plainte",
    steps: [
      "Vous pouvez déposer plainte à tout moment au commissariat.",
      "Faites constater vos blessures par un médecin (certificat médical).",
      "Notre service SAPV (Assistance Policière aux Victimes) peut vous accompagner.",
      "Vous n'avez pas besoin d'être séparé(e) pour porter plainte.",
      "Vous vous questionnez par rapport à votre situation ? Quelques outils sont disponibles ici"
    ],
    apporter: ["Certificat médical", "Photos des blessures ou dégâts", "Messages / preuves de menaces", "Identité de témoins éventuels"],
    contact: "069/66.98.20 (Péruwelz) — 0800/30.030 (SOS Violence conjugale)"
  },

  result_vio_conj_info: {
    type: "result", urgence: false,
    title: "Violence conjugale — Information & soutien",
    steps: [
      "Notre service SAPV vous accueille de manière confidentielle.",
      "Des associations spécialisées peuvent vous aider à prendre une décision.",
      "Vous pouvez aussi contacter le CPAS de votre commune pour un hébergement d'urgence."
    ],
    apporter: [],
    contact: "0800/30.030 (SOS Violence conjugale, gratuit) — SAPV : 069/66.98.20"
  },

  result_vs_urgent: {
    type: "result", urgence: true,
    title: "Violence sexuelle — Faits récents",
    steps: [
      "Appelez le <strong>112</strong> ou rendez-vous aux urgences les plus proches.",
      "<strong>Ne vous lavez pas</strong> et ne changez pas de vêtements — les traces ADN sont essentielles.",
      "Un médecin légiste pourra réaliser un kit médico-légal dans les 72 heures.",
      "Si vous le souhaitez, le service d'assistance policière aux victimes vous accompagnera tout au long de la procédure."
    ],
    apporter: ["Vêtements portés lors des faits (dans un sac séparé) si possible", "Tout objet pouvant contenir des traces si possible"],
    contact: "112 (urgence) — SOS Viol : 0800/98.100 (gratuit, 24h/24)",
    extra: "SOS Viol : <strong>0800/98.100</strong> (gratuit, 24h/24)"
  },

  result_vs_plainte: {
    type: "result", urgence: false,
    title: "Violence sexuelle — Déposer plainte",
    steps: [
      "Vous pouvez porter plainte même si les faits sont anciens.",
      "Un(e) policier(ère) spécialement formé(e) recueillera votre déclaration.",
      "Notre service SAPV vous accompagne avant, pendant et après la procédure."
    ],
    apporter: ["Tout élément de preuve disponible (messages, photos, témoins)", "Documents d'identité"],
    contact: "069/66.98.20 (Péruwelz) — SOS Viol : 0800/98.100"
  },

  result_harcelement_sexuel: {
    type: "result", urgence: false,
    title: "Harcèlement sexuel",
    steps: [
      "Conservez toutes les preuves (messages, emails, captures d'écran).",
      "Déposez plainte au commissariat.",
      "Si cela se passe au travail, informez également le conseiller en prévention."
    ],
    apporter: ["Copies des messages / emails / captures d'écran", "Dates et lieux des faits", "Identité de l'auteur si connue"],
    contact: "069/66.98.20 (Péruwelz) — 069/59.02.10 (Bernissart)"
  },

  result_accident_blesses: {
    type: "result", urgence: true,
    title: "Accident avec blessés",
    steps: [
      "Appelez le <strong>112</strong> pour les secours médicaux et le <strong>112</strong> pour la police.",
      "Ne déplacez pas les blessés (sauf danger imminent).",
      "Sécurisez la zone et balisez l'accident.",
      "Notez la plaque et les coordonnées des autres conducteurs impliqués."
    ],
    apporter: ["Permis de conduire", "Documents du véhicule"],
    contact: "112 (urgences médicales) — 112 (police)"
  },

  result_accident_materiel: {
    type: "result", urgence: false,
    title: "Accident matériel",
    steps: [
      "Remplissez un constat amiable avec l'autre conducteur.",
      "Si l'autre partie refuse ou si vous avez un doute sur la validité de ses documents ou sur son état ( conduite sous influence), appelez la police pour établir un procès-verbal.",
      "Photographiez les dégâts et la position des véhicules.",
      "Déclarez l'accident à votre assurance dans les délais prévus."
    ],
    apporter: ["Constat amiable", "Photos des dégâts", "Coordonnées des témoins"],
    contact: "069/66.98.20 si refus de constat"
  },

  result_delit_fuite: {
    type: "result", urgence: false,
    title: "Délit de fuite",
    steps: [
      "Notez immédiatement la plaque d'immatriculation, la marque et la couleur du véhicule.",
      "Recueillez les coordonnées de témoins.",
      "En l'absence de blessé et si votre véhicule est toujours en état de circuler vous pouvez déposer plainte au commissariat. Néanmoins, il est toujours utile de faire appel directement au 112 pour que le véhicule en fuite soit rapidement recherché par les équipes de police",
      "Prévenez votre assurance."
    ],
    apporter: ["Plaque d'immatriculation du fuyard (ou partie)", "Photos des dégâts", "Coordonnées des témoins"],
    contact: "069/66.98.20 (Péruwelz) — 069/59.02.10 (Bernissart)"
  },

  result_accident_parking: {
    type: "result", urgence: false,
    title: "Accident sur parking privé",
    steps: [
      "Demandez les images de vidéosurveillance du parking.",
      "Recherchez des témoins.",
      "Déposez plainte au commissariat.",
      "Contactez votre assurance."
    ],
    apporter: ["Photos des dégâts", "Coordonnées du parking", "Plaque du véhicule responsable si connue"],
    contact: "069/66.98.20 (Péruwelz)"
  },

  result_arnaque: {
    type: "result", urgence: false,
    title: "Arnaque / Abus de confiance",
    steps: [
      "Conservez tous les documents (contrats, reçus, échanges de messages).",
      "Déposez plainte au commissariat.",
      "En complément de votre plainte, vous pouvez également signaler via le SPF Économie : <a href='https://consumerconnect.be/fr/signalez-nous-une-infraction' target='_blank'>consumerconnect.be</a>."
    ],
    apporter: ["Contrats et factures", "Échanges de messages ou emails", "Preuves de paiement", "Identité de l'auteur si connue"],
    contact: "069/66.98.20 (Péruwelz) — SPF Économie : consumerconnect.be"
  },

  result_fraude_bancaire: {
    type: "result", urgence: true,
    title: "Fraude bancaire",
    steps: [
      "Bloquez immédiatement votre carte via <strong>Card Stop : 078/170.170</strong>.",
      "Contactez votre banque pour contester les transactions frauduleuses.",
      "Déposez plainte au commissariat.",
      "En complément de votre plainte, signalez également via le SPF Économie : <a href='https://consumerconnect.be/fr/signalez-nous-une-infraction' target='_blank'>consumerconnect.be</a>."
    ],
    apporter: ["Relevés bancaires avec les transactions suspectes", "Captures d'écran des échanges suspects"],
    contact: "Card Stop : 078/170.170 — 069/66.98.20 (Péruwelz)"
  },

  result_faux_policier: {
    type: "result", urgence: true,
    title: "Faux policier / Faux agent",
    steps: [
      "Ne donnez jamais d'argent ou de carte bancaire à un soi-disant policier.",
      "Appelez le <strong>112</strong> pour vérifier si une intervention est réelle.",
      "Déposez plainte immédiatement."
    ],
    apporter: ["Description de la personne", "Immatriculation du véhicule si disponible", "Montant soustrait si applicable"],
    contact: "112 (urgence)"
  },

  result_escroquerie_loc: {
    type: "result", urgence: false,
    title: "Escroquerie à la location",
    steps: [
      "Conservez toutes les preuves (annonce, échanges, preuves de paiement).",
      "Déposez plainte au commissariat.",
      "Signalez l'annonce sur la plateforme concernée."
    ],
    apporter: ["Lien ou capture de l'annonce", "Preuves de paiement", "Échanges avec le fraudeur"],
    contact: "069/66.98.20 (Péruwelz) — SPF Économie : consumerconnect.be"
  },

  result_abus_faiblesse: {
    type: "result", urgence: true,
    title: "Abus de faiblesse",
    steps: [
      "Signalez les faits au <strong>112</strong> ou au commissariat.",
      "Contactez le service social de la commune (CPAS).",
      "Notre service SAPV peut vous orienter vers les structures d'aide adaptées."
    ],
    apporter: ["Description des faits et de la personne impliquée", "Documents relatifs aux sommes prélevées"],
    contact: "112 — SAPV : 069/66.98.20"
  },

  result_phishing: {
    type: "result", urgence: false,
    title: "Phishing / Hameçonnage",
    steps: [
      "Changez immédiatement vos mots de passe (messagerie, banque, réseaux sociaux).",
      "Si des données bancaires ont été compromises, contactez votre banque et Card Stop.",
      "Déposez plainte au commissariat.",
      "Signalez le message sur <strong>suspect@safeonweb.be</strong>."
    ],
    apporter: ["Capture d'écran du message reçu", "URL du site frauduleux", "Relevés bancaires si fraude"],
    contact: "Card Stop : 078/170.170 — suspect@safeonweb.be"
  },

  result_piratage: {
    type: "result", urgence: false,
    title: "Piratage de compte",
    steps: [
      "Récupérez l'accès à votre compte via la procédure de récupération de la plateforme.",
      "Changez tous vos mots de passe et activez la double authentification.",
      "Déposez plainte au commissariat.",
      "Prévenez vos contacts si le compte a été utilisé pour les escroquer."
    ],
    apporter: ["Captures d'écran des activités suspectes", "Date et heure de la découverte du piratage"],
    contact: "069/66.98.20 — SPF Économie : consumerconnect.be"
  },

  result_sextorsion: {
    type: "result", urgence: true,
    title: "Sextorsion / Chantage en ligne",
    steps: [
      "<strong>Ne payez pas</strong> — le paiement n'arrête pas le chantage.",
      "Coupez tout contact avec l'auteur et bloquez-le.",
      "Conservez les preuves (captures d'écran) avant de supprimer.",
      "Déposez plainte au commissariat.",
      "Signalez sur <strong>ecopsco.be</strong> si impliquant un mineur."
    ],
    apporter: ["Captures d'écran des échanges et menaces", "Profil de l'auteur sur les réseaux sociaux"],
    contact: "112 ou 069/66.98.20 — Child Focus : 116.000"
  },

  result_achat_ligne: {
    type: "result", urgence: false,
    title: "Arnaque achat en ligne",
    steps: [
      "Conservez toutes les preuves (confirmation de commande, paiement, échanges).",
      "Contactez votre banque pour tenter un remboursement (retrovirement).",
      "Déposez plainte au commissariat.",
      "En complément de votre plainte, signalez le vendeur sur la plateforme et via le SPF Économie : <a href='https://consumerconnect.be/fr/signalez-nous-une-infraction' target='_blank'>consumerconnect.be</a>."
    ],
    apporter: ["Confirmation de commande", "Preuve de paiement", "Échanges avec le vendeur"],
    contact: "069/66.98.20 — SPF Économie : consumerconnect.be"
  },

  result_faux_support: {
    type: "result", urgence: false,
    title: "Faux support technique",
    steps: [
      "N'installez aucun logiciel à la demande d'un inconnu par téléphone.",
      "Si vous avez donné accès à votre ordinateur, déconnectez-le d'Internet.",
      "Changez tous vos mots de passe depuis un autre appareil.",
      "Déposez plainte au commissariat."
    ],
    apporter: ["Numéro de téléphone de l'appelant", "Description des actions effectuées sur l'ordinateur"],
    contact: "069/66.98.20 — SPF Économie : consumerconnect.be"
  },

  result_stalking: {
    type: "result", urgence: false,
    title: "Harcèlement",
    steps: [
      "Documentez chaque incident (date, lieu, description des faits).",
      "Conservez toutes les preuves (messages, photos, témoignages).",
      "Déposez plainte au commissariat — le harcèlement est une infraction pénale."
    ],
    apporter: ["Journal des incidents", "Captures d'écran des messages", "Identité de l'auteur", "Témoins"],
    contact: "069/66.98.20 (Péruwelz) — 112 si danger immédiat"
  },

  result_cyberharcelement: {
    type: "result", urgence: false,
    title: "Cyberharcèlement",
    steps: [
      "Faites des captures d'écran de tous les contenus harcelants.",
      "Bloquez l'auteur sur toutes les plateformes.",
      "Signalez les contenus auprès des plateformes concernées.",
      "Déposez plainte au commissariat.",
      "Si vous êtes mineur(e), parlez-en à un adulte de confiance."
    ],
    apporter: ["Captures d'écran des messages / publications", "URL des contenus problématiques", "Profil de l'auteur"],
    contact: "069/66.98.20 — Child Focus (mineurs) : 116.000"
  },

  result_harcelement_travail: {
    type: "result", urgence: false,
    title: "Harcèlement au travail",
    steps: [
      "Informez le conseiller en prévention aspects psychosociaux de votre entreprise.",
      "Conservez un journal des faits avec dates et témoins.",
      "Vous pouvez déposer plainte à la police ou via l'Inspection du travail.",
      "Le syndicat peut également vous accompagner."
    ],
    apporter: ["Journal des incidents", "Témoins éventuels", "Échanges écrits"],
    contact: "069/66.98.20 — SPF Emploi : 02/233.41.11"
  },

  result_harcelement_rue: {
    type: "result", urgence: false,
    title: "Harcèlement de rue / sexiste",
    steps: [
      "Déposez plainte au commissariat — le harcèlement de rue est une infraction depuis 2014 (loi sexisme).",
      "Notez le lieu, la date, l'heure et la description de l'auteur.",
      "Des témoins peuvent également être entendus."
    ],
    apporter: ["Description des faits et de l'auteur", "Lieu et heure précis", "Témoins éventuels"],
    contact: "069/66.98.20 (Péruwelz) — 069/59.02.10 (Bernissart)"
  },

  result_harcelement_voisins: {
    type: "result", urgence: false,
    title: "Harcèlement entre voisins",
    steps: [
      "Documentez chaque incident avec dates et descriptions.",
      "Tentez d'abord une médiation via le service de médiation communale.",
      "Déposez plainte au commissariat si le harcèlement persiste.",
      "Le juge de paix peut également être saisi pour des troubles de voisinage."
    ],
    apporter: ["Journal des incidents", "Photos / enregistrements si disponibles", "Témoignages de voisins"],
    contact: "069/66.98.20 — Médiation : commune de Bernissart ou Péruwelz"
  },

  result_degradation_vehicule: {
    type: "result", urgence: false,
    title: "Dégradation de véhicule",
    steps: [
      "Photographiez les dégâts du véhicule.",
      "Déposez plainte au commissariat. (Si le véhicule n'est plus en état de circuler, demandez un constat sur place)",
      "Prévenez votre assurance."
    ],
    apporter: ["Les documents de bord de votre véhicule"],
    contact: "069/66.98.20 (Péruwelz) — 069/59.02.10 (Bernissart)"
  },

  result_degradation_habitation: {
    type: "result", urgence: false,
    title: "Dégradation d'habitation",
    steps: [
      "Photographiez les dégâts.",
      "Déposez plainte au commissariat.",
      "Contactez votre assurance habitation.",
      "Si les dégâts sont importants, il peut s'avérer nécessaire de solliciter un constat sur place."
    ],
    apporter: ["Photos des dégâts", "Estimation des réparations", "Documents d'assurance"],
    contact: "069/66.98.20 (Péruwelz) — 069/59.02.10 (Bernissart)"
  },

  result_tags: {
    type: "result", urgence: false,
    title: "Tags / Graffitis",
    steps: [
      "Photographiez les tags.",
      "Déposez plainte au commissariat.",
      "Si cela se passe sur un bien public, signalez le également à l'administration communale."
    ],
    apporter: ["Photos des tags", "Date et lieu de découverte"],
    contact: "069/66.98.20 (Péruwelz) — 069/59.02.10 (Bernissart)"
  },

  result_degradation_mobilier: {
    type: "result", urgence: false,
    title: "Dégradation de boîte aux lettres / sonnette",
    steps: [
      "Photographiez les dégâts.",
      "Déposez plainte au commissariat."
    ],
    apporter: ["Photos des dégâts", "Date et lieu", "Identité du suspect si connue"],
    contact: "069/66.98.20 (Péruwelz) — 069/59.02.10 (Bernissart)"
  },

  result_menaces: {
    type: "result", urgence: false,
    title: "Menaces",
    steps: [
      "Conservez toutes les preuves de menaces (messages, emails, enregistrements).",
      "Si vous vous sentez en danger immédiat, appelez le <strong>112</strong>.",
      "Déposez plainte au commissariat.",
      "Informez votre entourage si nécessaire."
    ],
    apporter: ["Captures d'écran ou copies des menaces", "Identité de l'auteur si connue", "Témoins"],
    contact: "112 (si danger immédiat) — 069/66.98.20"
  },

  result_discrimination: {
    type: "result", urgence: false,
    title: "Discrimination / Racisme",
    steps: [
      "Déposez plainte au commissariat.",
      "Vous pouvez également contacter <strong>Unia</strong> (Centre Interfédéral pour l'égalité des chances).",
      "Conservez toutes les preuves."
    ],
    apporter: ["Description des faits", "Preuves éventuelles (messages, témoins)", "Documents d'identité"],
    contact: "069/66.98.20 — Unia : 0800/144.44 (gratuit)"
  },

  result_autre: {
    type: "result", urgence: false,
    title: "Autre infraction",
    steps: [
      "Contactez le commissariat pour exposer votre situation.",
      "Un policier vous orientera vers la procédure adaptée.",
      "En cas de doute sur l'urgence, appelez le 112."
    ],
    apporter: ["Description des faits", "Documents d'identité", "Toute preuve disponible"],
    contact: "112 (urgence) — 069/66.98.20 (Péruwelz) — 069/59.02.10 (Bernissart)"
  },

  result_temoin_urgent: {
    type: "result", urgence: true,
    title: "Signalement urgent",
    steps: [
      "Appelez le <strong>112</strong> immédiatement.",
      "Restez en ligne et donnez le maximum d'informations (lieu précis, description des faits et des personnes).",
      "Ne vous mettez pas en danger."
    ],
    apporter: [],
    contact: "112 (urgence)"
  },

  result_temoin_declaration: {
    type: "result", urgence: false,
    title: "Déclaration de témoin",
    steps: [
      "Rendez-vous au commissariat pour donner votre déclaration.",
      "Notez à l'avance tout ce dont vous vous souvenez (dates, lieux, descriptions).",
      "Votre témoignage est précieux pour l'enquête."
    ],
    apporter: ["Documents d'identité", "Notes sur les faits observés"],
    contact: "069/66.98.20 (Péruwelz) — 069/59.02.10 (Bernissart)"
  },
}

export default class extends Controller {
  static targets = ["messages", "options", "backBtn", "restart"]

  connect() {
    this.history = []
    this.show("start")
  }

  show(nodeId) {
    const node = TREE[nodeId]
    if (!node) return

    this.currentNode = nodeId
    this.messagesTarget.innerHTML = ""
    this.optionsTarget.innerHTML = ""

    if (node.type === "result") {
      this.renderResult(node)
    } else {
      this.renderQuestion(node)
    }

    this.backBtnTarget.classList.toggle("d-none", this.history.length === 0)
  }

  renderQuestion(node) {
    const bubble = document.createElement("div")
    bubble.className = "chat-policier mb-3"
    bubble.innerHTML = `
      <div class="policier-wrapper">
        <img src="/images/policier-bulle.png" alt="Policier" class="policier-img"/>
        <div class="policier-bulle-text">${node.message}</div>
      </div>
    `
    this.messagesTarget.appendChild(bubble)

    node.options.forEach(opt => {
      const btn = document.createElement("button")
      btn.className = "btn btn-outline-primary btn-sm mb-2 w-100 text-start"
      btn.textContent = opt.label
      btn.addEventListener("click", () => {
        this.history.push(this.currentNode)
        this.show(opt.next)
      })
      this.optionsTarget.appendChild(btn)
    })
  }

  renderResult(node) {
    const urgenceHtml = node.urgence
      ? `<div class="alert alert-danger d-flex align-items-center gap-2 mb-3">
           <strong>🚨 Situation urgente</strong> — Appelez le 112
         </div>`
      : ""

    const stepsHtml = node.steps.map(s => `<li class="mb-1">${s}</li>`).join("")

    const apporterHtml = node.apporter?.length
      ? `<div class="mt-3">
           <h6 class="fw-bold">📋 Ce qu'il faut préparer / apporter</h6>
           <ul class="mb-0">${node.apporter.map(a => `<li>${a}</li>`).join("")}</ul>
         </div>`
      : ""

    const extraHtml = node.extra
      ? `<div class="alert alert-info mt-3 mb-0"><small>${node.extra}</small></div>`
      : ""

    this.messagesTarget.innerHTML = `
      ${urgenceHtml}
      <div class="card border-primary">
        <div class="card-header bg-primary text-white fw-bold">${node.title}</div>
        <div class="card-body">
          <h6 class="fw-bold">✅ Que faire ?</h6>
          <ol>${stepsHtml}</ol>
          ${apporterHtml}
          <hr>
          <p class="mb-0"><strong>📞 Contact :</strong> ${node.contact}</p>
          ${extraHtml}
        </div>
      </div>
    `

    const btn = document.createElement("button")
    btn.className = "btn btn-success w-100 mt-2"
    btn.innerHTML = "Nouvelle question"
    btn.addEventListener("click", () => {
      this.history = []
      this.show("start")
    })
    this.optionsTarget.appendChild(btn)
  }

  back() {
    if (this.history.length === 0) return
    const prev = this.history.pop()
    this.show(prev)
  }
}
